import { motion } from "framer-motion";

const WHATSAPP_NUMBER = "5511998686751";
const WHATSAPP_MESSAGE = encodeURIComponent("Olá! Gostaria de saber mais sobre os serviços da Duali Soluções.");
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export const WhatsAppButton = () => {
  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, duration: 0.4, type: "spring" }}
      className="fixed bottom-6 right-6 z-[10000] w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-all duration-300"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <svg viewBox="0 0 32 32" fill="white" width="28" height="28">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.502 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.96a15.907 15.907 0 008.832 2.674C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.338 22.614c-.39 1.1-2.282 2.104-3.142 2.166-.86.062-1.672.388-5.634-1.172-4.776-1.878-7.78-6.764-8.016-7.078-.234-.312-1.918-2.548-1.918-4.862 0-2.312 1.214-3.452 1.644-3.922.43-.47.938-.588 1.252-.588.312 0 .626.002.898.016.29.016.676-.11 1.058.806.39.938 1.332 3.234 1.45 3.468.116.234.194.508.038.82-.156.312-.234.508-.468.782-.234.274-.492.612-.702.82-.234.234-.478.488-.206.958.274.47 1.216 2.006 2.612 3.25 1.794 1.598 3.306 2.092 3.776 2.326.47.234.744.196 1.018-.118.274-.312 1.174-1.37 1.486-1.84.312-.47.626-.39 1.058-.234.43.156 2.742 1.292 3.212 1.528.47.234.782.35.898.546.118.196.118 1.132-.272 2.232z" />
      </svg>
    </motion.a>
  );
};
